export enum DefaultRestockSuggestionSupplier  {
  AllSuppliers = '[All Suppliers]',
  MyWarehouse = '[My Warehouse]',
  Unassigned = 'Unassigned'
}

export const RESTOCK_SUPPLIER_ROW_TOOLTIPS: Record<string, string> = {
  [DefaultRestockSuggestionSupplier.Unassigned]: 'Show SKUs/items not linked to any supplier but still in your warehouse',
  [DefaultRestockSuggestionSupplier.MyWarehouse]: 'Show items that currently have stock in your warehouse',
  [DefaultRestockSuggestionSupplier.AllSuppliers]: 'Show all items that have restock suggestions',
};
